import { createStore } from 'vuex';

// Import from webapp/stores/ (already migrated)
import modules from '@/stores';

export default createStore({
    modules,
});
